export class CanvasState {
    constructor(lp, relativePosition, getVerticalOffset) {
        this.lp = lp;
        this.relativePosition = relativePosition;
        this.getVerticalOffset = getVerticalOffset;
    }
}
